export enum SettingsTeamMemberStatusEnum {
  'MEMBER' = 'member',
  'INVITED' = 'invited'
}
